import { Root } from "./wrapRootElement"
import "./src/style.css"
export const wrapRootElement = Root
